import React from 'react'
import TicketList from '../ticket-list'

const Pending = () => (
  <TicketList
    title="Pending Tickets List"
    statusFilter="Pending"
    editableStatuses={['Pending', 'Solved']}
    displayStatus={(s) => s}
  />
)

export default Pending
